import React from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import logo from './loginLogo.png';

import '../../Helpers/print.css';

function DocsLogo() {
  return (
    <Card
      sx={{
        maxWidth: 345,
        border: 'none',
        boxShadow: 'none',
        margin: ' 0 auto',
        padding: '8px 0 0 0 ',
      }}
    >
      <img
        className='justify_logo_print'
        style={{
          minWidth: '250px',
          maxWidth: '250px',
          maxHeight: '100%',
          padding: '1px',
        }}
        src={logo}
        alt='logo'
      />

      {/* <CardMedia
        component="img"
        height="auto"
        width="auto"
        image={logo}
        alt="Multilayer Logo"
      /> */}
    </Card>
  );
}

export default DocsLogo;
